<div style="background-color: #F5F7F8; height: 92vh; overflow-y: scroll; padding: 7px; overflow-x: hidden;">
    <div *ngIf="!this.isUserLogged" class="row" style="padding: 10px;">
        <div class="col-9" >
            <h3 style="margin: 10px; font-size: 26px; font-weight: bold;">{{ this.pageDetails().gotoprofile }} </h3>
        </div>
        <div class="col-3">
            <button type="button" class="btn btn-primary" style=" margin-top: 5px; " (click)="this.goToLogin()"> {{ this.pageDetails().login }} </button>
        </div>
    </div>
    <div *ngIf="this.isUserLogged" class="row">
        <div class="col-8" style="padding: 30px;">
            <h4 style="display: inline-block;  font-weight: bold; font-size: 20px; margin: 0px;">{{ this.loggedUser?.data?.fist_name + ' ' + this.loggedUser?.data?.last_name }} </h4>
        </div>
        <div class="col-4">
            <img style="display: inherit; width: 45px; height: 45px; margin: auto;position: absolute; top: 0px;left: 0px;right: 0px;bottom: 0px;" class="rounded-circle avatar" (click)="this.onAccountTap(login)" [src]="this.image" alt="">

        </div>
    </div>
    <div style="margin-bottom: 10px; background-color: white; padding: 10px; border-radius: 10px;" >
        <div (click)="this.onAccountTap(login)" style="margin-top: 7px;">
            <img style="display: inline-block; width: 28px; height: 28px; margin-right: 10px; position: relative; top:  1px;" src="/assets/images/account/account-account.svg" alt="">
            <p style="display: inline-block; position: relative; top: 5px;">{{ this.pageDetails().account }}</p>
        </div>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;">

        <div (click)="this.onSettingsTap(login)" style="margin-top: 7px;">
            <img style="display: inline-block; width: 28px; height: 28px; margin-right: 10px; position: relative; top:  1px;" src="/assets/images/account/account-settings.svg" alt="">
            <p style="display: inline-block; position: relative; top: 5px;">{{ this.pageDetails().settings }}</p>
        </div>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;">

        <!-- <div (click)="this.invite()" style="margin-top: 7px;">
            <img style="display: inline-block; width: 28px; height: 28px; margin-right: 10px; position: relative; top:  1px;" src="/assets/images/account/account-invite-earn.svg" alt="">
            <p style="display: inline-block; position: relative; top: 5px;">{{ this.pageDetails().invite }}</p>
        </div>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;"> -->

        <div (click)="this.onVouchersClick(login)" style="margin-top: 7px;">
            <img style="display: inline-block; width: 28px; height: 28px; margin-right: 10px; position: relative; top:  2px;" src="/assets/images/account/account-vouchers.svg" alt="">
            <p style="display: inline-block; position: relative; top: 5px;">{{ this.pageDetails().vouchers }}</p>
        </div>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;">

        <div (click)="this.onContactsTap()" style="margin-top: 7px;">
            <img style="display: inline-block; width: 28px; height: 28px; margin-right: 10px; position: relative; top:  1px;" src="/assets/images/account/account-support.svg" alt="">
            <p style="display: inline-block; position: relative; top: 5px;">{{ this.pageDetails().contacts }}</p>
        </div>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;">

        <div (click)="this.onDocumentsTap()" style="margin-top: 7px;">
            <img style="display: inline-block; width: 28px; height: 28px; margin-right: 10px; position: relative; top:  1px;" src="/assets/images/account/account-legal.svg" alt="">
            <p style="display: inline-block; position: relative; top: 5px;">{{ this.pageDetails().legal }}</p>
        </div>
    </div>

    <div style="margin-top: 30px; background-color: white; padding: 10px; border-radius: 10px;" >
        <div style="margin-top: 7px;">
            <img style="display: inline-block; width: 28px; height: 28px; margin-right: 10px; position: relative; top:  1px;" src="/assets/images/account/account-rate.svg" alt="">
            <p style="display: inline-block; position: relative; top: 5px;">{{ this.pageDetails().rate }}</p>
        </div>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;">

        <div (click)="this.oprenUrl(this.config.facebookUrl)" style="margin-top: 7px;">
            <img style="display: inline-block; width: 28px; height: 28px; margin-right: 10px; position: relative; top:  1px;" src="/assets/images/account/account-facebook.svg" alt="">
            <p style="display: inline-block; position: relative; top: 5px;">{{ this.pageDetails().facebook }}</p>
        </div>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;">

        <div (click)="this.oprenUrl(this.config.instagramUrl)" style="margin-top: 7px;">
            <img style="display: inline-block; width: 28px; height: 28px; margin-right: 10px; position: relative; top:  1px;" src="/assets/images/account/account-instagram.svg" alt="">
            <p style="display: inline-block; position: relative; top: 5px;">{{ this.pageDetails().instagram }}</p>
        </div>
    </div>

    <div *ngIf="this.isUserLogged" style="margin-top: 30px; background-color: white; padding: 10px; border-radius: 10px;" >
        <div (click)="this.logOut(logout)" style="margin-top: 7px;">
            <img style="display: inline-block; width: 28px; height: 28px; margin-right: 10px; position: relative; top:  1px;" src="/assets/images/account/account-signout.svg" alt="">
            <p style="display: inline-block; position: relative; top: 5px;">{{ this.pageDetails().logout }}</p>
        </div>
    </div>
</div>

<ng-template #logout let-modal>
    <div style="text-align: center; padding: 20px; border-radius: 20px;">
        <h3 style="padding: 20px; font-weight: bold;">Сигурни ли сте, че искате да излезете от профила си?</h3>
        <div mat-dialog-actions>
            <button class="btn btn-primary" style=" border-radius: 0px; border-bottom-left-radius: 20px; background-color: white; border: 1px solid #B6BFD6; color: black; float: left; width: 50%; color: #858585" mat-button (click)="modal.close()">Върни се</button>
            <button class="btn btn-primary" style="border-radius: 0px; border-bottom-right-radius: 20px; background-color: white; border: 1px solid #B6BFD6; color: black; float: right; width: 50%; font-weight: bold;" mat-button (click)="this.logOutFromApp(modal)" cdkFocusInitial>Излез</button>
          </div>
    </div>
</ng-template>

<ng-template #login let-modal>
    <div style="text-align: center;"> 
        <img src="/assets/images/account/image-login.png" alt="" style="height: 140px; width: 160px; margin-top: 30px; margin-bottom: 20px;"> <br>
        <p style="font-weight: bold; margin-top: 7px;">Влез в профила си за да продължиш</p>
    </div>
    <div class="row" style="margin-top: 25px; margin-bottom: 15px;">
        <div class="col-6" style="text-align: center;">
            <button class="btn btn-primary" style="border-color: transparent; width: 90%; background-color: #E4F2FE; color: #0A69EB" mat-button (click)="this.registration(modal)">Регистрация</button>

        </div>
        <div class="col-6" style="text-align: center;">
            <button class="btn btn-primary" style="width: 90%;"  mat-button (click)="this.loginNavigation(modal)">Влез</button>
        </div>
    </div>
</ng-template>

